'use client'
import React from 'react'

export default function Pagination2({
  totalPages = 4,
  currentPage = 1,
  onChange,
}) {
  const handlePageClick = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return
    if (pageNumber === currentPage) return
    onChange?.(pageNumber)
  }

  const getPageNumbers = () => {
    const pages = []

    // 總頁數小於等於 10，全部顯示
    if (totalPages <= 10) {
      return Array.from({ length: totalPages }, (_, i) => i + 1)
    }

    // 目前頁前後要顯示幾頁
    const siblingCount = 3

    pages.push(1)

    let start = Math.max(2, currentPage - siblingCount)
    let end = Math.min(totalPages - 1, currentPage + siblingCount)

    // 一開始時，多顯示前面的頁數
    if (currentPage <= 5) {
      start = 2
      end = 7
    }

    // 快到最後時，多顯示後面的頁數
    if (currentPage >= totalPages - 4) {
      start = totalPages - 6
      end = totalPages - 1
    }

    if (start > 2) {
      pages.push('...')
    }

    for (let i = start; i <= end; i++) {
      pages.push(i)
    }

    if (end < totalPages - 1) {
      pages.push('...')
    }

    pages.push(totalPages)

    return pages
  }
  return (
    <nav
      className={`shop-pages d-flex align-items-center ${
        totalPages > 1 ? 'justify-content-between' : 'justify-content-center'
      } mt-3`}
      aria-label="Page navigation"
    >
      {totalPages > 1 && (
        <a
          href="#"
          className={`btn-link d-inline-flex align-items-center flex-shrink-0 ${
            currentPage === 1 ? 'disabled' : ''
          }`}
          onClick={(e) => {
            e.preventDefault()
            handlePageClick(currentPage - 1)
          }}
        >
          <svg
            className="me-1"
            width="7"
            height="11"
            viewBox="0 0 7 11"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use href="#icon_prev_sm" />
          </svg>
          <span className="fw-medium">上一頁</span>
        </a>
      )}

      <ul className="pagination mb-0 flex-wrap justify-content-center">
        {getPageNumbers().map((page, index) => (
          <li key={`${page}-${index}`} className="page-item">
            {page === '...' ? (
              <span className="px-1 mx-2">...</span>
            ) : (
              <a
                className={`btn-link px-1 mx-2 ${
                  currentPage === page ? 'btn-link_active' : ''
                }`}
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  handlePageClick(page)
                }}
              >
                {page}
              </a>
            )}
          </li>
        ))}
      </ul>

      {totalPages > 1 && (
        <a
          href="#"
          className={`btn-link d-inline-flex align-items-center flex-shrink-0 ${
            currentPage === totalPages ? 'disabled' : ''
          }`}
          onClick={(e) => {
            e.preventDefault()
            handlePageClick(currentPage + 1)
          }}
        >
          <span className="fw-medium me-1">下一頁</span>
          <svg
            width="7"
            height="11"
            viewBox="0 0 7 11"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use href="#icon_next_sm" />
          </svg>
        </a>
      )}
    </nav>
  )
}
